import { useMutation } from '@tanstack/react-query';
import { useApi } from '../useApi';

export function useCompanyEvents() {
  const getApi = useApi();

  const getEvents = async (userId: string) => {
    const api = await getApi();
    const res = await api.creditMonitoringCompaniesForUser(userId);

    return res;
  };

  const mutation = useMutation({
    mutationFn: getEvents,
  });

  return mutation;
}
